import styled from 'styled-components';

export const MessageWrapper = styled.div`
  display: flex;
  padding: 8px 12px;
  align-items: center;
  gap: 12px;
  align-self: stretch;
  border-radius: 4px;
  border: 1px solid ${({ theme }) => theme.colors.purple3};
  background: ${({ theme }) => theme.colors.purple1};
  color: ${({ theme }) => theme.colors.black9};
  font-size: 14px;
  font-weight: 400;
  line-height: 16px;
  margin-bottom: 24px;
`;

export const TitleText = styled.h1`
  margin: 0;
  color: ${({ theme }) => theme.colors.black9};
  font-size: 30px;
  font-weight: 600;
  letter-spacing: -0.5px;
  line-height: 40px;
`;

export const ColoredText = styled.span`
  color: ${({ theme }) => theme.colors.green6};
`;
export const SlidesWrapper = styled.div`
  display: flex;
  transition: transform 0.5s ease-in-out;
`;

export const SlideWrapper = styled.div`
  min-width: 100%;
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  align-items: center;
  max-height: 80vh;
  overflow-y: auto;
`;

export const StepWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 32px;
  color: ${({ theme }) => theme.colors.black9};
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  overflow-y: auto;

  @media (min-width: ${({ theme }) => theme.mediaQueries.sm}) {
    height: 60vh;
  }

  .ant-input {
    width: 100%;
  }

  .ant-picker {
    width: 100%;
  }
`;

export const FinalStepWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  gap: 32px;
  color: ${({ theme }) => theme.colors.black9};
  font-size: 14px;
  line-height: 20px;
  overflow-y: auto;

  @media (min-width: ${({ theme }) => theme.mediaQueries.sm}) {
    height: 70vh;
  }
`;

export const LogoImg = styled.img<{ isWelcomeOnboarding: boolean }>`
  width: 122px;
  height: 26px;
  position: fixed;
  left: 50%;
  top: 32px;
  transform: translateX(-50%);

  @media (min-width: ${({ theme }) => theme.mediaQueries.sm}) {
    width: 122px;
    height: 26px;
  }
  ${({ theme, isWelcomeOnboarding }) => {
    const maxHeight = isWelcomeOnboarding ? theme.mediaQueries.xs : '810px';

    return `
      @media (max-height: ${maxHeight}) {
        display: none;
      }
    `;
  }}
`;

export const MaxHeightWrapper = styled.div`
  flex-grow: 1;
  overflow-y: auto;
  max-height: 50vh;
`;
